'use client';

import React, { useContext } from 'react';
import Modal from '../molecules/modal';
import { ModalContext } from '../../contexts/modal-provider';

const TrailerModal = () => {
  const { modalState, closeModal } = useContext(ModalContext);

  // Extract the video ID from the YouTube URL
  const videoId = modalState.videoSrc ? modalState.videoSrc.split('v=')[1] : null;

  return (
    <Modal showCloseBtn={true} isOpen={modalState.type === 'VIDEO_MODAL'} onClose={closeModal}>
      {videoId ? (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="h-screen w-screen"
        ></iframe>
      ) : (
        <video controls autoPlay className="h-screen w-screen bg-black">
          <source src={modalState.videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </Modal>
  );
};

export default TrailerModal;